import {IconType} from "react-icons";

export enum PillStatus {
  ACTIVE = "Active",
  ACTIVE_INCIDENTS = "Active Incidents",
  ACTIVE_INTEGRATION = "Active Integration",
  ACTIVE_MAINTENANCE = "Active Maintenance",
  CRITICAL = "Critical",
  DEGRADED_PERFORMANCE = "Degraded Performance",
  DELETED = "Deleted",
  DOWN = "Down",
  ENDED = "Ended",
  ERROR = "ERROR",
  GENERAL_NOTICE = "General Notice",
  IDENTIFIED = "Identified",
  IGNORED = "Ignored",
  INVESTIGATING = "Investigating",
  INTEGRATION_EVENT_ALERT_RAISED = "Event: Integration Alert Raised",
  INTEGRATION_EVENT_ALERT_CLEARED = "Event: Integration Alert Cleared",
  INTEGRATION_EVENT_PERIODIC = "Event: Integration Periodic",
  INTEGRATION_EVENT_PERIODIC_RAW = "Event: Integration Periodic Raw",
  INTEGRATION_EVENT_RECONFIGURED = "Event: Integration Reconfigured",
  INTEGRATION_EVENT_TIMESERIES = "Event: Integration Timeseries",
  INTEGRATION_EVENT_TEST = "Event: Integration Test",
  IN_MAINTENANCE = "In Maintenance",
  MAINTENANCE = "Maintenance",
  MAINTENANCE_EVENT_ENTERED = "Event: Maintenance Started",
  MAINTENANCE_EVENT_EXITED = "Event: Maintenance Ended",
  MAINTENANCE_EVENT_CHECK_PAUSED = "Event: Maintenance Checks Paused",
  MAINTENANCE_EVENT_CHECK_RESUMED = "Event: Maintenance Checks Resumed",
  MAINTENANCE_EVENT_SCHEDULE_CREATED = "Event: Scheduled",
  MAINTENANCE_EVENT_SCHEDULE_UPDATED = "Event: Schedule Updated",
  MAINTENANCE_EVENT_SCHEDULE_DELETED = "Event: Schedule Deleted",
  MAINTENANCE_EVENT_SCHEDULE_PAUSED = "Event: Schedule Paused",
  MAINTENANCE_EVENT_SCHEDULE_RESUMED = "Event: Schedule Resumed",
  MAINTENANCE_EVENT_EXCEPTION_ADDED = "Event: Exception Added",
  MAINTENANCE_EVENT_OCCURRENCE_STARTED = "Event: Occurrence Started",
  MAINTENANCE_EVENT_OCCURRENCE_COMPLETED = "Event: Occurrence Completed",
  MAINTENANCE_EVENT_OCCURRENCE_CANCELED = "Event: Occurrence Canceled",
  MAINTENANCE_EVENT_OCCURRENCE_REPLACED = "Event: Occurrence Replaced",
  MAINTENANCE_EVENT_NOTIFICATION_CREATED = "Event: Notification Created",
  MAINTENANCE_EVENT_NOTIFICATION_UPDATED = "Event: Notification Updated",
  MAINTENANCE_EVENT_NOTIFICATION_DELETED = "Event: Notification Deleted",
  MAINTENANCE_EVENT_NOTIFICATION_SENT = "Event: Notification Sent",
  MONITORING = "Monitoring",
  NOTIFICATION = "Notification",
  NOT_CONFIGURED = "Not Configured",
  NOT_REPORTING = "NOT_REPORTING",
  NO_CHANGE = "NO_CHANGE",
  OK = "OK",
  ONGOING = "Ongoing",
  OPERATIONAL = "Operational",
  OUTAGE = "OUTAGE",
  OUTAGE_REPORTED = "Outage Reported",
  PARTIAL_OUTAGE = "PARTIAL_OUTAGE",
  PAUSED = "Paused",
  PENDING = "Pending",
  READY_TO_DEPLOY = "READY_TO_DEPLOY",
  RESOLVED = "Resolved",
  SCHEDULED = "Scheduled",
  SCHEDULED_MAINTENANCE = "Scheduled Maintenance",
  SILENCED = "Silenced",
  UNKNOWN = "Unknown",
  UNREACHABLE = "Unreachable",
  UP = "Up",
  WARNING = "Warning",
}

export const STATUS_PILL_STATUS = Object.values(PillStatus);
export const STATUS_PILL_COLORS = ["green", "blue", "yellow", "orange", "red", "gray"] as const;
export const STATUS_PILL_VARIANTS = ["text", "icon", "textAndIcon"] as const;
export const STATUS_PILL_TYPES = ["incident", "component", "checks"] as const;

export type StatusPillStatus = (typeof STATUS_PILL_STATUS)[number];
export type StatusPillColor = (typeof STATUS_PILL_COLORS)[number];
export type StatusPillVariant = (typeof STATUS_PILL_VARIANTS)[number];
export type StatusPillType = (typeof STATUS_PILL_TYPES)[number];

export type StatusPillDisplayConfig = {
  icon?: IconType;
  color: StatusPillColor;
  displayName: string;
};

export type StatusPillProps = {
  type: StatusPillType;
  status: StatusPillStatus;
  variant: StatusPillVariant;
  className?: string;
  mobileStatus?: StatusPillStatus;
  disabled?: boolean;
};
